// Port of api/fuel/app/classes/insights/plays/counts.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'counts',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlPlayers = players ? ' AND p.play_players = ' + players : ''

        var plays = Util.queryFast(
            'SELECT p.play_players, SUM(p.play_count) AS play_count' +
            ' FROM play p' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND p.play_players > 0' +
            sqlPlayers +
            ' GROUP BY p.play_players'
        )

        var counts = {}
        for (var i = 0; i < plays.length; i++) {
            var pc = plays[i].play_players
            if (!counts[pc]) counts[pc] = 0
            counts[pc] += parseInt(plays[i].play_count, 10)
        }

        return {
            counts: counts
        }

    }
})
